import { DropdownButton, Spinner } from "react-bootstrap"

export const ExportButton = ({ loading, children, disabled }) => (
  <DropdownButton
    title={
      loading ? (
        <Spinner animation="border" variant="white" size="sm" />
      ) : (
        "Export"
      )
    }
    variant="warning text-white"
    disabled={disabled}
  >
    {children}
  </DropdownButton>
)
